module.exports = __webpack_public_path__ + "static/media/check.fdd607fb.svg";